import React from 'react'
import './../../css/accountChallenge.css';
import phoneSymbol from './phone_symbol.png'
import emailSymbol from './email_symbol.png'
import { Navigate } from 'react-router-dom';
import ROUTES from './../../constants/routes';
import {ResultCodes} from './../../constants/utilities';
import {connect} from 'react-redux';
import AxiosDataService from '../../services/AxiosDataService';
import spinner from './../../Spinnerimage.gif';  
import {OnDisplayContactPageLoad,OnDisplayToolTip,OnDisplayContactCancel,OnDisplayContactContinue} from './../../components/SiteCat/SiteCat'
import {onUserCancel} from './../../constants/merchantData';                     


class DisplayContactChannels extends React.Component {

  constructor(){
    super();
    this.state = {
    phoneContactChannels: [],
    emailContactChannels: [],
    displayPhoneContactChannels: false,
    displayEmailContactChannels: false,
    selectedOption: '',
    pageName:"",
    linkId: '',
    doRedirect: false,
    showPhoneContact:false,
    showEmailContact:false,
    isLoaded: false,
    merchantName:""
    };
  }

  componentDidMount() {
    OnDisplayContactPageLoad(this.state.merchantName);
    const jwtTokenData = this.props.contactposts.jwtToken.jwtToken
    const cancelUrl = this.props.contactposts.cancelUrl
    this.setState({
      merchantName : this.props.contactposts.merchant,
      jwtTokenData,
      cancelUrl,
      last4Digit:this.props.contactposts.last4Digit
    });

    const linkFIResponse= this.props.contactposts.linkfiresponse;
  
    const contactChannelsArray = linkFIResponse.contactChannels;
    this.setState({linkId: linkFIResponse.linkId}); 
    const uniqueContactChannelsArray =  Array.from(new Set(contactChannelsArray.map(contactChannel => contactChannel.maskedValue)))

    .map(maskedValue => {
      return contactChannelsArray.find(contactChannel => contactChannel.maskedValue === maskedValue);
    });
    
    const phoneContactArray = uniqueContactChannelsArray.filter(contactChannel => {
      let maskedValue = `${contactChannel.maskedValue}`
      var maskedValueString = maskedValue.toString();
      if(maskedValueString.includes("xxx-xxx")){
        return contactChannel;
      }
      return null;
    })
    this.setState({phoneContactChannels: phoneContactArray});

    if(phoneContactArray && phoneContactArray.length){
      this.setState({displayPhoneContactChannels: true})
      var contactIdentifier = phoneContactArray[0].contactIdentifier;
      var phoneUsage = contactIdentifier.substring(0, 1);
      var contactId = contactIdentifier.substring(2);
      var textContactIdentifier = phoneUsage + "S" + contactId;
      this.setState({selectedOption: textContactIdentifier})
      this.setState({showPhoneContact:true});
    }

    const emailContactArray =  uniqueContactChannelsArray.filter(contactChannel => {
      let maskedValue = `${contactChannel.maskedValue}`
      var maskedValueString = maskedValue.toString();
      if(maskedValueString.includes("@")){
        return contactChannel;
      }
      return null;
    })
    this.setState({emailContactChannels: emailContactArray});

    if(emailContactArray && emailContactArray.length){
      this.setState({showEmailContact:true});
      this.setState({displayEmailContactChannels: true})

      if(!(phoneContactArray && phoneContactArray.length)){
        let contactIdentifier = emailContactArray[0].contactIdentifier;
        this.setState({selectedOption: contactIdentifier})
        this.setState({showEmailContact:true});
      }
    }
  }

  handleFormSubmit = event =>{
    event.preventDefault();
   
    this.setState({
      isLoaded: true
    })
   

 
    var selectedvalue = this.state.selectedOption;
    var selectedvalueArray = selectedvalue.split('-');
    var identifierValue = selectedvalueArray[0];
    var linkId = this.state.linkId;
    let contactmethodData ;
    const textStr = ['HS','WS','SS'];
    const voiceStr  = ['HV','WV','SV'];
    const emailStr  = ['EE'];
    const getContactMethod = identifierValue.substring(0, 2);
    
    if(textStr.includes(getContactMethod)){
      contactmethodData = 'Text';
    }else if(voiceStr.includes(getContactMethod)){
      contactmethodData = 'AutoMessage';
    }else if(emailStr.includes(getContactMethod)){
      contactmethodData = 'EmailAddress';
    }else{
      contactmethodData = '';
    }
    OnDisplayContactContinue(contactmethodData, this.state.merchantName);
    let userData = {
      identifier: identifierValue,
      linkId: linkId,
      merchantName: this.state.merchantName
   }
   let randomstring = require('random-string');
   const self = this;
   const options = {
          url: "oob/sendCode",    // + Config.env,
          method: "post",
          headers: {
                "Access-Control-Allow-Origin": "*",
                //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
                'Content-Type': 'application/json',
                 "REQUEST_ID": randomstring({length: 20})
                  },
          data: JSON.stringify(userData)
                };
                AxiosDataService.fetch(options).then((responsedata) => {
                
                  self.setState({
                    isLoaded: false
                  })
                  let response=responsedata.data;
                self.props.dispatch({
                  type:'SENDCODE_RESPONSE',
                   response
                  });
                  this.setState({ selectedOption: selectedvalue});
                if(response.resultCode === ResultCodes.VALIDATE_OOB_PAGE){
                  self.setState({ pageName: "ValidateCodePage" });
                  self.setState({doRedirect: true});
                } else if(response.resultCode === ResultCodes.TOOMANY_OOBS_REQSTED){
                    self.setState({ pageName: "TooManyCodesRequestedPage" });
                    self.setState({doRedirect: true});
                } else if(response.resultCode === ResultCodes.CARD_MEMBER_LOCKOUT){
                    self.setState({ pageName: "LockedOutPage" });
                    self.setState({doRedirect: true});
                } else if(response.resultCode === ResultCodes.CARD_MEMBER_LOCKOUT){
                    let resData = response.eligibleAccountVO;

                      if (resData.length === 1) {
                        self.props.dispatch({
                          type:'LOGIN_RESPONSE',
                          linkId: response.linkId,
                           response
                          });
                        self.setState({ pageName: "SingleCardPage" });
                        self.setState({ doRedirect: true });
                      } else if (resData.length > 1) {
                        self.props.dispatch({
                          type:'LOGIN_RESPONSE',
                          linkId: response.linkId,
                           response
                          });
                        self.setState({ pageName: "MultiCardPage" });
                        self.setState({ doRedirect: true });
                      } else {
                        self.setState({ pageName: "TryLinkingAgainPage" });
                        self.setState({ doRedirect: true });
                      }
                    
                    
                    
                }else{
                    self.setState({ pageName: "TryLinkingAgainPage" });
                    self.setState({doRedirect: true});
                  }
              },(errorResponse) => {
                 self.setState({
                   isLoaded: false,
                   pageName: "TryLinkingAgainPage", 
                   selectedOption: selectedvalue, 
                   doRedirect: true 
                  
                });
          })
  }

  handleOptionChange = event =>{
    this.setState({
      selectedOption: event.target.value
    });
  }

  //hover tooltip link..
  toggleHover = event => OnDisplayToolTip(this.state.merchantName);

  phoneElementOptions(maskedValue, textContactIdentifier, voiceContactIdentifier, indexval){

    const phoneElementOptions = <div>
    <div className = "row row-margin">
    <div className="col-xs-offset-1 xxx-xxx-1234-by">
    [{maskedValue}] by
    </div>
    </div>

  <div className = "row row-margin">
        <div className = "col-xs-offset-1 phoneDiv" role="radiogroup">
         <label class="container-100 textContainer " for={"text_"+indexval}>
          <input type="radio" name="radio" class="radio-custom"  id={"text_"+indexval} value= {textContactIdentifier}  checked={this.state.selectedOption === textContactIdentifier} onChange={this.handleOptionChange} />
          <span class="checkmark checkmark-radiobutton"><span>Text</span></span>
          </label>

          <label class="container-100 phoneContainer "  for={"call_"+indexval}>
          <input type="radio" name="radio" class="radio-custom"  id={"call_"+indexval} value= {voiceContactIdentifier}  checked={this.state.selectedOption === voiceContactIdentifier} onChange={this.handleOptionChange} />
          <span class="checkmark checkmark-radiobutton"><span className = "no-word-wrap">Phone Call</span></span>
          </label>
           </div>
           </div>
    </div>;
    return phoneElementOptions;
  }

emailElementOptions(maskedEmailAddress, contactIdentifier, indexval){
 const emailContactelement = <div className = "row row-margin">
 <div className="col-xs-offset-1 marginleftAlign" role="radiogroup">
 <label class="container-100 emailContainer"  for={"email_"+indexval}><p class="contactemailAddress">{maskedEmailAddress}</p>
 <input type="radio" name="radio" class="radio-custom" id={"email_"+indexval} value= {contactIdentifier} checked={this.state.selectedOption === contactIdentifier} onChange={this.handleOptionChange}/>
 <span class="checkmark checkmark-radiobutton"></span>
 </label></div> </div>;
return emailContactelement;
}

redirectCancel = event => {
  OnDisplayContactCancel();
  this.sendCodeOnCancel();
  const self = this;

  let AccLinkingResponse = self.props.contactposts.loginresponse.eligibleAccountVO;
  if (AccLinkingResponse.length === 1) {
    self.setState({ pageName: "SingleCardPage" });
    self.setState({ doRedirect: true });
  } else if (AccLinkingResponse.length > 1) {
    self.setState({ pageName: "MultiCardPage" });
    self.setState({ doRedirect: true });
  } else {
    self.setState({ pageName: "TryLinkingAgainPage" });
    self.setState({ doRedirect: true });
  }
}

sendCodeOnCancel = () => {
  this.setState({
    isLoaded: true,
    oobCancel: true
  });
 
  var selectedvalue = this.state.selectedOption;
  var selectedvalueArray = selectedvalue.split('-');
  var identifierValue = selectedvalueArray[0];
  var linkId = this.state.linkId;
  let contactmethodData ;
  const textStr = ['HS','WS','SS'];
  const voiceStr  = ['HV','WV','SV'];
  const emailStr  = ['EE'];
  const getContactMethod = identifierValue.substring(0, 2);
  
  if(textStr.includes(getContactMethod)){
    contactmethodData = 'Text';
  }else if(voiceStr.includes(getContactMethod)){
    contactmethodData = 'AutoMessage';
  }else if(emailStr.includes(getContactMethod)){
    contactmethodData = 'EmailAddress';
  }else{
    contactmethodData = '';
  }
  OnDisplayContactContinue();
  let userData = {
    identifier: identifierValue,
    linkId: linkId,
    merchantName: this.state.merchantName,
    oobCancel: true
 }
 let randomstring = require('random-string');
 const self = this;
 const options = {
        url: "oob/sendCode",    // + Config.env,
        method: "post",
        headers: {
              "Access-Control-Allow-Origin": "*",
              //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
              'Content-Type': 'application/json',
               "REQUEST_ID": randomstring({length: 20})
                },
        data: JSON.stringify(userData)
              };
              AxiosDataService.fetch(options).then((responsedata) => {
                self.setState({
                  isLoaded: false
                })
                let response=responsedata.data;
               
                this.setState({ selectedOption: selectedvalue});

                if(response.resultCode === ResultCodes.REDIRECT_TO_MERCHANT){
                  let data = {
                    merchantName: this.state.merchantName,
                    cancelUrlData: this.state.cancelUrl
                  }
                  onUserCancel(data);
                
                }else if(response.resultCode === ResultCodes.ACCT_LINKING_PAGE){
                  //let AccLinkingResponse = self.props.contactposts.linkfiresponse.eligibleAccountVO;
                  let AccLinkingResponse = self.props.contactposts.linkfiresponse.eligibleAccountVO ? self.props.contactposts.linkfiresponse.eligibleAccountVO : self.props.contactposts.loginresponse.eligibleAccountVO
                    if (AccLinkingResponse.length === 1) {
                      self.setState({ pageName: "SingleCardPage" });
                      self.setState({ doRedirect: true });
                    } else if (AccLinkingResponse.length > 1) {
                      self.setState({ pageName: "MultiCardPage" });
                      self.setState({ doRedirect: true });
                    } else {
                      self.setState({ pageName: "TryLinkingAgainPage" });
                      self.setState({ doRedirect: true });
                    }
                
                }
                else{
                  self.setState({ pageName: "TryLinkingAgainPage" });
                  self.setState({doRedirect: true});
                }
            },(errorResponse) => {
               self.setState({
                 isLoaded: false,
                 pageName: "TryLinkingAgainPage", 
                 selectedOption: selectedvalue, 
                 doRedirect: true 
                
              });
            });
      }


  render(){

    if(this.state.doRedirect === true){
      //TODO: Need to change to validate OOB page for success
			if (this.state.pageName === "ValidateCodePage"){
				return <Navigate to={ROUTES.PATH.ValidateCodePage} replace />
			}else if (this.state.pageName === "TooManyCodesRequestedPage"){
				return <Navigate to={ROUTES.PATH.TooManyCodesRequestedPage} replace />
			}else if (this.state.pageName === "LockedOutPage"){
				return <Navigate to={ROUTES.PATH.LockedOutPage} replace />
      } else if (this.state.pageName === "SingleCardPage") {
          return <Navigate to={ROUTES.PATH.SingleCardPage} replace />
        } else if (this.state.pageName === "MultiCardPage") {
          return <Navigate to={ROUTES.PATH.MultiCardPage} replace />
         } else if (this.state.pageName === "TechDiff") {
            return <Navigate to={ROUTES.PATH.TechDiff} replace />
        }else{
          return <Navigate to={ROUTES.PATH.TryLinkingAgainPage} replace />
        }
    }else {
      let isLoadervalue = this.state.isLoaded;
    return(
      <React.Fragment>
         {isLoadervalue ?
               <div className="spinner">
               <img src={spinner} alt="Spinner"/>
             </div> : null
          }

        <div class = "conatiner">
        <br/>
        <p className="Confirm-Your-Identit">{"Confirm Your Identity"}</p>
        <br/>
        <div className="For-your-protection">
        For your protection we’ll need to send you a temporary
        identification code.
        <br/>
        <br/>
        Please select your preferred contact method.
        </div>
     <br/>
     { this.state.showPhoneContact ?
       <div class = "row row-margin">
      <div class="col-xs-offset-1 marginleftAlign">
        <div className="My-Phone-Number">
        {this.state.displayPhoneContactChannels ? <PhoneResults/>: null}
      </div>
      </div>
      </div>:null}
        {
          this.state.phoneContactChannels.map((contactChannel, index) => {
            let maskedValue = `${contactChannel.maskedValue}`
            var maskedValueString = maskedValue.toString();
              var subString1 = ("(").concat(maskedValueString.substring(0, 3)).concat(")").concat(" ");
              var subString2 = maskedValueString.substring(4);
              var maskedPhoneNumber = subString1.concat(subString2);
            
              let contactIdentifier = `${contactChannel.contactIdentifier}`
              var phoneUsage = contactIdentifier.substring(0, 1);
              var contactId = contactIdentifier.substring(2);

              var textContactIdentifier = phoneUsage + "S" + contactId;
              var voiceContactIdentifier = phoneUsage + "V" + contactId;
        
             const phoneOptions =  this.phoneElementOptions(maskedPhoneNumber, textContactIdentifier, voiceContactIdentifier, index);
            return(
              <React.Fragment>
              {phoneOptions}
            </React.Fragment>
            )
          })
        }
     
     {this.state.showEmailContact?   <div class = "row row-margin">
      <div class="col-xs-offset-1 marginleftAlign">
      <div className="My-Email-Address">
      {this.state.displayEmailContactChannels ? <EmailResults/>: null}
      </div></div></div>:null}
      <div  className = "emailGroup">

        {
          this.state.emailContactChannels.map((contactChannel,index) => {
            if(!this.state.displayEmailContactChannels === true){
              this.displayEmailContactChannels();
          }
          let maskedEmailAddress = `${contactChannel.maskedValue}`
          var emailAddrSignIndex = maskedEmailAddress.indexOf("@");
          var emailAddrText = maskedEmailAddress.substring(0, emailAddrSignIndex);
          var emailAddrDomainText = maskedEmailAddress.substring(emailAddrSignIndex);
        
          if(emailAddrText.length > 10){
            var maskText = "*";
            var maskedEmailAddressText = maskText.repeat(10);
            var emailAddrStartText = emailAddrText.substring(0, 1);
            var emailAddrEndText = emailAddrText.substring(emailAddrText.length - 1);
            maskedEmailAddress = emailAddrStartText + maskedEmailAddressText + emailAddrEndText + emailAddrDomainText;
          }
            const emailOptions = this.emailElementOptions(maskedEmailAddress, contactChannel.contactIdentifier,index);
            return(
              <React.Fragment>
                {emailOptions}
            </React.Fragment>
            )
          })
        }
      </div>
   
        <div className = "By-choosing-a-contac">

        By choosing a contact method, you allow<br/>
            Discover to send you a temporary <br/>
        identification code. Message and  <br/>
            data rates may apply.
        </div>
          <div className="help-tip" x-ms-format-detection="none">
            <div className="Need-to-change-your ">
              <button class="changebtnproperty" onMouseEnter={this.toggleHover}> Need to change your contact information?</button>

            </div>
            <div className="help-tip-sub">
              <p> If none of your contact information displayed is valid, please contact us
              at <span >1-800-347-2655.</span></p>
              <br />
              <p>Note: For your added security, recently updated contact information may not be available to receive the temporary identification code.</p>
            </div>
          </div>
       
        <div className = "row row-margin submit-buttonDiv">
        <input type="submit" class="btn-primary btn-primary-custom Button-Text submit" value="Continue" id="continue-button" onClick={ this.handleFormSubmit}/>
        </div>
        <div className="row row-margin submit-buttonDiv Text-Link"><button class="changebtnproperty" onClick={this.redirectCancel}>Cancel</button></div>

        </div>
        
      </React.Fragment>

    );
  }
  }
}

function PhoneResults(props) {
  return (
  <div>
    My Phone Number
  <img src={phoneSymbol} className = "Fill-3 phoneSymbolDiv" alt="Phone"></img>
  </div>
  )
}

function EmailResults(props) {
  return (
  <div>
    My Email Address
    <img src={emailSymbol} className = "Fill-3" alt="eMail"></img>
  </div>
  )
}

const mapStateToProps = (state) => {
  return {
    contactposts: state
  }
}


export default connect(mapStateToProps)(DisplayContactChannels);
